// extracted by mini-css-extract-plugin
export var wrapper = "faq-module--wrapper--1ca4a";